import { SidebarProvider } from "@/shared/ui/sidebar";
import { AppNav } from "@/widgets/shell/AppNav";
import { ShellContextStrip } from "@/widgets/shell/ShellContextStrip";
import { CommandPalette } from "@/widgets/shell/CommandPalette";
import { TopNavbar } from "@/widgets/TopNavbar";
import { AdvisorLauncher, AdvisorLauncherProvider } from "@/widgets/AdvisorLauncher";
import { WhatsNewDialog } from "@/widgets/WhatsNewDialog";
import { LicenseReadonlyBanner } from "@/widgets/LicenseReadonlyBanner";
import { usePreferenceSync } from "@/entities/profile";

interface AdminLayoutProps {
  children: React.ReactNode;
}

export function AdminLayout({ children }: AdminLayoutProps) {
  // 登录后用服务端偏好(主题/语言)覆盖本地,跨设备一致
  usePreferenceSync();
  return (
    <SidebarProvider>
      <AdvisorLauncherProvider>
        <div className="min-h-screen flex w-full">
          <AppNav />
          <div className="flex-1 flex flex-col min-w-0">
            <TopNavbar />
            {/* OEM W5 私有化:授权只读横幅(撞 423 LICENSE_READONLY 后亮) */}
            <LicenseReadonlyBanner />
            {/* 窄屏(<lg)的上下文条:顶栏塞不下,落成 header 下方独立一行(≥lg 由 TopNavbar 内嵌那份接管) */}
            <ShellContextStrip variant="row" />
            {/*
             * 不要给 main 加 overflow-auto:页面实际由 window 滚动(min-h-screen 让 main 随内容
             * 增高、从不内部滚动),而 overflow-auto 会把 position:sticky 的参照系劫持到这个「不滚动
             * 的」main 上,导致模版生图/视频左栏预览 sticky 失效、滑下去就消失。保持 overflow:visible
             * 让 sticky 对视口生效。横向过宽的页面各自用局部 overflow-x 容器处理。
             */}
            <main className="cyber-page flex-1 p-4 md:p-6">{children}</main>
          </div>
          <AdvisorLauncher />
          {/* ⌘K 命令面板:全局快捷跳群/舱(仅租户壳,组件内按 scope 自门控) */}
          <CommandPalette />
          {/* 首次打开弹一次(§21.3):第一次登录弹新手指引,老用户遇到新版本弹本次更新。
              组件内按 scope 与 localStorage 自门控,平台超管不弹。 */}
          <WhatsNewDialog />
        </div>
      </AdvisorLauncherProvider>
    </SidebarProvider>
  );
}
